import { FallbackRender } from "@sentry/react";
import { PageFallback, DevFeedback } from "@jana-technology/platform-ui";

import { reloadWindow } from "./helpers";

export const MainPageFallback = ({ error }: Parameters<FallbackRender>[0]) => {
  const _error = error as Error;

  const name = _error.name || "Unknown Error";
  const message =
    _error.message || "Non-standard error was thrown. Check the console.";

  return (
    <PageFallback onPrimaryClick={reloadWindow} primaryButtonText="Reload">
      {import.meta.env.DEV ? (
        <DevFeedback errorName={name} errorMessage={message} />
      ) : null}
    </PageFallback>
  );
};

export default MainPageFallback;
